import { amplitudeHandler, testHandler } from './handlers'
import { INFRASTRUCTURE_ENVIRONMENT_TYPE } from '@/constants'
import { loadingCollector, memoryCollector } from './collectors'
import type { EventConfig, Handler, Environment } from './types'

const ENV: Environment = INFRASTRUCTURE_ENVIRONMENT_TYPE

// ============================================================================
// EVENT KEYS
// ============================================================================

export const KEYS = {
  MEMORY: 'Memory Snapshot',
  MODEL_LOADED: 'Model Loaded',
  VIEW_BATCH: 'View Batch',
} as const

export type EventKey = (typeof KEYS)[keyof typeof KEYS]

// ============================================================================
// HANDLERS - Filtered by environment
// ============================================================================

function getHandlersForEnvironment(): Handler[] {
  const handlers: Handler[] = []

  if (amplitudeHandler.environments.includes(ENV)) {
    handlers.push(amplitudeHandler)
  }

  if (testHandler.environments.includes(ENV) || import.meta.env.DEV) {
    handlers.push(testHandler)
  }

  return handlers
}

const handlers = getHandlersForEnvironment()

// ============================================================================
// EVENT KEYS CONFIGURATION
// Maps keys to handlers AND data collectors
// ============================================================================

export const EVENT_KEYS: Record<EventKey, EventConfig> = {
  [KEYS.MODEL_LOADED]: {
    handlers,
    collector: loadingCollector,
  },

  [KEYS.MEMORY]: {
    handlers,
    collector: memoryCollector,
  },

  [KEYS.VIEW_BATCH]: {
    handlers,
  },

  // #TODO: Enable Sentry error tracking
  // [KEYS.ERROR]: {
  //   handlers: [sentryHandler],
  // },
}
